import { RefObject, useEffect } from 'react'

import { type TreeItemIndex, type TreeRef } from 'react-complex-tree'

import { TreeItems } from '../types.js'

/**
 * Expands, focuses, and scrolls to a tree item when `targetIndex` is set.
 * Calls `onComplete` after the scroll so the caller can clear the target.
 */
export function useScrollToTreeItem(
  treeRef: RefObject<TreeRef | null>,
  targetIndex: TreeItemIndex | undefined,
  items: TreeItems,
  onComplete: () => void,
) {
  useEffect(() => {
    if (!targetIndex || !items[targetIndex]) {
      return
    }

    requestAnimationFrame(() => {
      treeRef.current?.expandItem(targetIndex)
      treeRef.current?.focusItem(targetIndex)

      requestAnimationFrame(() => {
        document
          .querySelector(`[data-rct-item-id="${String(targetIndex)}"]`)
          ?.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        onComplete()
      })
    })
  }, [targetIndex, items, treeRef, onComplete])
}
